


function ReviewsTableHead(){
  
    return (
            <tr>
                <th>Review id</th>
                <th>User</th>
                <th>Rating</th>
                <th>Title</th>
                <th>Review</th>
            </tr>
        )
}



export default ReviewsTableHead;